export default __webpack_public_path__ + "static/media/Shape.c7f90f55.svg";